import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import { SurveyEmoji1Icon } from '../../../../../assets/svg/survey/emojis/SurveyEmoji1Icon';
import { SurveyEmoji2Icon } from '../../../../../assets/svg/survey/emojis/SurveyEmoji2Icon';
import { SurveyEmoji3Icon } from '../../../../../assets/svg/survey/emojis/SurveyEmoji3Icon';
import { SurveyEmoji4Icon } from '../../../../../assets/svg/survey/emojis/SurveyEmoji4Icon';
import { SurveyEmoji5Icon } from '../../../../../assets/svg/survey/emojis/SurveyEmoji5Icon';
import { Text } from '../../../../../react-components/Text';

type RouteSurveyStarsProps = {
  onSelectStar: (rating: number) => void;
};

const surveyIcons = [
  { name: `star1`, icon: <SurveyEmoji1Icon /> },
  { name: `star2`, icon: <SurveyEmoji2Icon /> },
  { name: `star3`, icon: <SurveyEmoji3Icon /> },
  { name: `star4`, icon: <SurveyEmoji4Icon /> },
  { name: `star5`, icon: <SurveyEmoji5Icon /> },
];

export const RouteSurveyStars = ({ onSelectStar }: RouteSurveyStarsProps) => {
  return (
    <Grid key="step-0" className="animate__animated animate__fadeIn">
      <Text
        variant="body-large"
        intlId="route_survey.step-0.title"
        style={{ color: RoutalPalette.secondary00, textAlign: `center` }}
      />
      <VSpacer large />
      <Grid container direction="row" alignItems="center" height={`100%`} justifyContent="center">
        {surveyIcons.map((valuation, index) => {
          return (
            <Grid
              key={`icon-${valuation.name}`}
              item
              style={{
                cursor: `pointer`,
                width: `44px`,
                height: `44px`,
                display: `flex`,
                justifyContent: `center`,
                alignItems: `center`,
                borderRadius: `10px`,
              }}
              onClick={() => {
                onSelectStar(index + 1);
              }}
            >
              {valuation.icon}
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};
